import {
  review1,
  review2,
  review3,
  review4,
  review5,
  review6,
} from "../../assets/images";

export const testimonials = [
  {
    name: "Aanya Shekhawat",
    city: "Jaipur, Rajasthan",
    stars: 5,
    image: review1,
    feedback:
      "INET-GPT simplified everything for me—from tough maths to English practice. I cleared the written exam in my first attempt!",
  },
  {
    name: "Aditya Pradhan",
    city: "Lucknow, Uttar Pradesh",
    stars: 5,
    image: review2,
    feedback:
      "The AI feedback and daily current affairs on INET-GPT made me confident. I even improved my communication for the SSB!",
  },
  {
    name: "Zoya Khan",
    city: "Srinagar, Jammu & Kashmir",
    stars: 5,
    image: review3,
    feedback:
      "As a girl from Kashmir with limited access to coaching, INET-GPT gave me everything I needed at home. Truly a blessing!",
  },
  {
    name: "Rohan Pillai",
    city: "Kochi, Kerala",
    stars: 5,
    image: review4,
    feedback:
      "The mock tests, reasoning tricks, and AI mentor helped me score high in all sections. It's better than offline coaching!",
  },
  {
    name: "Tejas Mehta",
    city: "Ahmedabad, Gujarat",
    stars: 5,
    image: review5,
    feedback:
      "I was preparing while doing my college. INET-GPT's flexible schedule, videos, and instant doubt-solving made it all possible.",
  },
  {
    name: "Sneha Raut",
    city: "Nagpur, Maharashtra",
    stars: 5,
    image: review6,
    feedback:
      "I struggled with English and current affairs earlier. INET-GPT gave me confidence and structure. Now I feel Navy-ready!",
  },
];
